import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import {
    getCardIcon,
    // getFormattedTime,
    getHoursIndayFormat
} from '../../utils/helper'

function ExtendDetails(props) {
    const { className, extendedDetails, paymentData} = props
    
    useEffect(() => {
        
    },[EMPTY_ARRAY])


    return (
        <div>
            
            {extendedDetails?.length > 0 && <div className={`${className}`}>
                    <table className='table table-responsive small mt-2'>
                        <tbody>
                            {extendedDetails?.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <span className="text-primary">{index == 0 && paymentData?.reservation?.thirdparty_integration_id === '1' ? 'Started(Paid at Aggregator)' : index == 0 ? 'Started' : paymentData?.is_overstay == '1' ? 'Overstay' : paymentData?.is_extended == '1' ?'Extended':'Started'}</span>
                                            <small className="d-block text-muted"><i className="far fa-clock"></i> {`${Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.day ? getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.day : 0) > 1 ? Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.day) + ' Days ' : Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.day ? getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.day : 0) > 0 ? Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.day) + ' Day ' : ''}
                                                ${Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.hour : 0) > 1 ? Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.hour) + ' Hrs ' : Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.hour ? getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.hour : 0) > 0 ? Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.hour) + ' Hr ' : ''}
                                                ${Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.minute : 0) > 1 ? Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.minute) + ' Mins' : Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.minute ? getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.minute : 0) > 0 ? Number(getHoursIndayFormat(Number(item?.length).toFixed(2), false)?.minute) + ' Min ' : ''}`}
                                            </small>
                                        </td>
                                        <td className="text-end">
                                            {index == 0 ? `$${item?.total}` : ` $${Number(item?.total)?.toFixed(2)}`}<br />
                                            
                                            <img src={getCardIcon(item?.payment_method?item?.payment_method:'')} style={{height: '10px', padding: '0'}}  alt="" />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    
                </div>}
        </div>
    )
}

ExtendDetails.propTypes = {
    dispatch: PropTypes.func,
    className: PropTypes.string,
    extendedDetails: PropTypes.array,
    paymentData: PropTypes.object,
}

ExtendDetails.defaulProps = {
    dispatch: noop,
    className: '',
    extendedDetails: EMPTY_ARRAY,
    paymentData: EMPTY_OBJECT,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ExtendDetails)